'use client'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'
import { UserCog } from 'lucide-react'
import type { EquipeMember } from '../types'

interface EquipeEventoCardProps {
  equipe: EquipeMember[]
}

export function EquipeEventoCard({ equipe }: EquipeEventoCardProps) {
  if (!equipe || equipe.length === 0) {
    return null // Ou pode retornar um card com uma mensagem de "Nenhuma equipe definida"
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <UserCog className="h-5 w-5 text-primary" />
          Equipe do Evento
        </CardTitle>
        <CardDescription>Membros com permissões especiais no evento.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {equipe.map((membro) => (
          <div key={membro.id} className="flex items-center gap-3">
            <Avatar className="h-10 w-10">
              <AvatarImage src={membro.avatar_url || undefined} />
              <AvatarFallback>{membro.nome_exibicao.charAt(0)}</AvatarFallback>
            </Avatar>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <p className="font-medium">{membro.nome_exibicao}</p>
                {membro.criador && <Badge className="text-xs">Criador</Badge>}
              </div>
              <div className="flex flex-wrap gap-1 pt-1">
                {membro.permissoes.editar_evento && <Badge variant="outline">Pode Editar</Badge>}
                {membro.permissoes.confirmar_pagamento && (
                  <Badge variant="outline">Confirma Pag.</Badge>
                )}
                {membro.permissoes.excluir_evento && (
                  <Badge variant="destructive">Pode Excluir</Badge>
                )}
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
